var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArchives = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84712 17.7222C4.80078 19.7757 4.80078 22.464 4.80078 27.8405C4.80078 33.217 4.80078 35.9052 5.84712 37.9588C6.7675 39.7651 8.23612 41.2337 10.0425 42.1541C12.096 43.2005 14.7843 43.2005 20.1608 43.2005H27.8408C33.2173 43.2005 35.9055 43.2005 37.9591 42.1541C39.7654 41.2337 41.2341 39.7651 42.1544 37.9588C43.2008 35.9052 43.2008 33.217 43.2008 27.8405C43.2008 22.464 43.2008 19.7757 42.1544 17.7222C41.2341 15.9158 39.7654 14.4472 37.9591 13.5268C35.9055 12.4805 33.2173 12.4805 27.8408 12.4805H20.1608C14.7843 12.4805 12.096 12.4805 10.0425 13.5268C8.23612 14.4472 6.7675 15.9158 5.84712 17.7222ZM25.1253 21.1809C24.852 20.8393 24.4383 20.6405 24.0008 20.6405C23.5634 20.6405 23.1497 20.8393 22.8764 21.1809L19.0364 25.9809C18.5396 26.6019 18.6403 27.5081 19.2613 28.0049C19.8823 28.5017 20.7885 28.401 21.2853 27.78L22.5608 26.1856V33.6005C22.5608 34.3958 23.2055 35.0405 24.0008 35.0405C24.7961 35.0405 25.4408 34.3958 25.4408 33.6005V26.1856L26.7164 27.78C27.2132 28.401 28.1194 28.5017 28.7404 28.0049C29.3614 27.5081 29.4621 26.6019 28.9653 25.9809L25.1253 21.1809Z",
    fill: "url(#paint0_linear_9461_23416)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3871 7.61256C37.5753 4.80078 33.0499 4.80078 23.9989 4.80078C14.9479 4.80078 10.4224 4.80078 7.61066 7.61256C6.15629 9.06693 5.45418 10.9798 5.11523 13.7403C6.13411 12.6062 7.35836 11.6615 8.73309 10.961C10.2335 10.1965 11.8402 9.88648 13.6191 9.74114C15.3378 9.60072 17.4525 9.60075 20.0382 9.60078H27.9595C30.5453 9.60075 32.66 9.60072 34.3787 9.74114C36.1576 9.88648 37.7642 10.1965 39.2647 10.961C40.6394 11.6615 41.8637 12.6062 42.8825 13.7403C42.5436 10.9798 41.8415 9.06693 40.3871 7.61256Z",
    fill: "url(#paint1_linear_9461_23416)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9461_23416",
    x1: 4.80078,
    y1: 12.4805,
    x2: 34.7715,
    y2: 49.9439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FFA99E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70808"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9461_23416",
    x1: 5.11523,
    y1: 4.80078,
    x2: 9.12265,
    y2: 21.7312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FFA99E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70808"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArchives, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Archives.aafd8112.svg";
export { ForwardRef as ReactComponent };